import LayoutAdmin from "view/ExampleLayout/Admin";
import AllInput from "view/Template/AllInput";

const route = [
	{
		exact: true,
		path: "/AllInput",
		component: AllInput,
		layout: LayoutAdmin
	}
];

export default route;